import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 140px;
  border-bottom: 1px solid #7b7b7b61;

  a {
    color: #fff;
  }
`;
